import styled from 'styled-components';

export const CSSWidgetPresenceList = styled.ul`
    flex: 1;
    display: flex;
    flex-direction: column;
    list-style: none;
`;

export const CSSWidgetPresenceListItem = styled.li``;

export const CSSWidgetPresenceListItemProgressBar = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CSSWidgetPresenceListItemBtn = styled.button<{ isDisabled: boolean }>`
    width: 100%;
    padding: ${(props) => props.theme.space.md}px;
    gap: 10px;
    min-height: 64px;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    background-color: ${(props) => props.theme.color.white};
    align-items: center;
    opacity: ${(props) => (props.isDisabled ? 0.4 : 1)};
    &:hover {
        background-color: ${(props) => props.theme.color.grey1};
    }
`;

export const CSSWidgetPresenceLabel = styled.div<{ isOn: boolean }>`
    flex: 1;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${(props) => (props.isOn ? props.theme.font.weight.semiBold : props.theme.font.weight.normal)};
`;

export const CSSWidgetPresenceAvatar = styled.div`
    flex: 1;
    display: flex;
`;
